import { Routes, Route } from 'react-router-dom';
import { useMemo } from 'react';

import { clusterApiUrl } from '@solana/web3.js';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import {
    GlowWalletAdapter,
    LedgerWalletAdapter,
    PhantomWalletAdapter,
    SlopeWalletAdapter,
    SolflareWalletAdapter,
    SolletExtensionWalletAdapter,
    SolletWalletAdapter,
    TorusWalletAdapter,
} from '@solana/wallet-adapter-wallets';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';

import Header from 'src/components/header/Header';
import Home from 'src/screens/home/Home';
import Login from 'src/screens/login/Login';
import Signup from 'src/screens/signup/Signup';
import PageNotFound from 'src/screens/page-not-found/PageNotFound';
import { LOCAL_STORAGE_TOKEN_KEY } from 'src/utils/constants';
import AllTransactions from 'src/screens/all-transactions/AllTransactions';
import Withdraw from 'src/screens/withdraw/Withdraw';
import CreateMerchantForm from 'src/screens/create-merchant-form/CreateMerchantForm';
import MerchantSales from 'src/screens/merchant-sales/MerchantSales';
import Settings from './screens/settings/Settings';

import './App.css';
import { UserProfileProvider } from './context/user-context/UserProvider';
import ResetPassword from './screens/reset-password/ResetPassword';
require('@solana/wallet-adapter-react-ui/styles.css');

function App() {
    const solNetwork = WalletAdapterNetwork.Mainnet;
    const endpoint = useMemo(() => clusterApiUrl(solNetwork), [solNetwork]);
    const wallets = useMemo(
        () => [
            new PhantomWalletAdapter(),
            new GlowWalletAdapter(),
            new SlopeWalletAdapter(),
            new SolflareWalletAdapter({ solNetwork }),
            new TorusWalletAdapter(),
            new LedgerWalletAdapter(),
            new SolletExtensionWalletAdapter(),
            new SolletWalletAdapter(),
        ],
        [solNetwork]
    );

    if (!localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY)) {
        return (
            <div className="App text-sm">
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/reset-password/:token" element={<ResetPassword />}></Route>
                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            </div>
        );
    }

    return (
        <UserProfileProvider>
            <ConnectionProvider endpoint={endpoint}>
                <WalletProvider wallets={wallets}>
                    <WalletModalProvider>
                        <div className="App text-sm">
                            <Header />
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/withdraw" element={<Withdraw />} />
                                <Route path="/all-transactions" element={<AllTransactions />} />
                                <Route path="/merchant/create" element={<CreateMerchantForm />}></Route>
                                <Route path="/merchant/:formId" element={<MerchantSales />}></Route>
                                <Route path="/merchant" element={<MerchantSales />}></Route>
                                <Route path="/settings" element={<Settings />}></Route>
                            </Routes>
                        </div>
                    </WalletModalProvider>
                </WalletProvider>
            </ConnectionProvider>
        </UserProfileProvider>
    );
}

export default App;
